import { Injectable, OnDestroy, inject } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceOrientationServiceService implements OnDestroy {
  private deviceService = inject(DeviceDetectorService);

  private isMobilePortraitSubject = new BehaviorSubject<boolean>(false);
  isMobilePortrait$ = this.isMobilePortraitSubject.asObservable();
  isMobilePortrait = false;

  constructor() {
    this.checkDeviceOrientation();
    window.addEventListener('orientationchange', this.handleOrientationChange.bind(this));
  }

  ngOnDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationChange.bind(this));
  }

  private checkDeviceOrientation() {
    const isMobile = this.deviceService.isMobile();
    const orientation = window.orientation;
    this.isMobilePortrait = isMobile && (orientation === 0 || orientation === 180);
    this.isMobilePortraitSubject.next(this.isMobilePortrait);
  }

  private handleOrientationChange() {
    this.checkDeviceOrientation();
  }
}
